import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, Tooltip } from "recharts";
import { Loader2 } from "lucide-react";
import { useVendorDashboard } from "@/hooks/useVendor";
import { formatPrice, formatDate } from "@/lib/format";

export default function VendorStats() {
  const { data, isLoading } = useVendorDashboard();
  if (isLoading || !data) return <div className="flex h-64 items-center justify-center"><Loader2 className="h-7 w-7 animate-spin text-brand" /></div>;

  const cards = [
    { label: "Chiffre d'affaires brut", value: formatPrice(data.revenue) },
    { label: `Commission plateforme (${data.commission_percent}%)`, value: formatPrice(data.commission_amount) },
    { label: "Revenus nets disponibles", value: formatPrice(data.net_revenue) },
    { label: "Total ventes", value: data.units_sold },
  ];

  return (
    <div className="space-y-6" data-testid="vendor-stats">
      <div>
        <h1 className="font-display text-2xl font-extrabold text-ink">Statistiques</h1>
        <p className="mt-1 text-sm text-slate-500">Analyse détaillée de votre activité.</p>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {cards.map((c) => (
          <div key={c.label} className="rounded-2xl border border-line bg-white p-4">
            <p className="text-[11px] font-bold uppercase tracking-wide text-slate-400">{c.label}</p>
            <p className="mt-2 font-display text-xl font-extrabold text-ink">{c.value}</p>
          </div>
        ))}
      </div>
      <div className="rounded-2xl border border-line bg-white p-5">
        <p className="font-display text-base font-bold text-ink">Chiffre d'affaires — 30 derniers jours</p>
        <div className="mt-4 h-72">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data.chart}>
              <XAxis dataKey="day" tick={{ fontSize: 10 }} tickFormatter={(d) => d.slice(5)} interval={5} stroke="#94A3B8" />
              <YAxis tick={{ fontSize: 10 }} stroke="#94A3B8" width={44} />
              <Tooltip formatter={(v) => formatPrice(v)} labelFormatter={(d) => formatDate(d)} />
              <Bar dataKey="total" fill="#0052FF" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
